export default {
  cancel: 'Abbrechen',
  confirm: 'Bestätigen',
};
